<ng-template #content let-c="close">
    <div class="input-prompt">
        <div class="modal-body">
            <form [formGroup]="form">
                <div class="row mb-1 px-2 mt-2">
                    <div class="col-12 form-group">
                        <app-input-string-react formControlName="valor" [name]="'valor'" [form]="form"
                            [labelName]="this.label" [id]="'valor'" [required]="true">
                        </app-input-string-react>
                    </div>
                </div>
            </form>
        </div>
        <button class="btn btn-success mx-2 mb-1" (click)="OKMethod(c)" [disabled]="form.invalid"><i
                class="fa fa-check mx-2"></i>OK</button>
        <button class="btn btn-danger mx-2 mb-1" (click)="c('Close click')"><i class="fa fa-times mx-2"></i>
            Cancelar
        </button>
    </div>
</ng-template>